import React from "react";
import { Link } from "react-router-dom";
import logo from "../logo.svg";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-12 sm:pt-16 pb-6 sm:pb-8 border-t border-gray-800/50">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 mb-8">
          <div>
            <Link to="/" className="block mb-4">
              <img src={logo} alt="Estabild" className="h-7 sm:h-8 w-auto" />
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed font-body text-sm sm:text-base">
              Automated reporting on real estate development projects.
            </p>
            <div className="space-y-2">
              <p className="text-xs sm:text-sm text-gray-400 font-body">
                Email
              </p>
              <a
                href="mailto:hello@estabild.com"
                className="text-white hover:text-primary-400 transition-colors font-body font-medium text-sm sm:text-base"
              >
                hello@estabild.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-3 sm:mb-4 text-white text-sm sm:text-base">
              PRODUCT
            </h4>
            <ul className="space-y-2 text-sm sm:text-base">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-white transition-all duration-200 font-body hover:translate-x-1 inline-block"
                >
                  Overview
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/funding"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Funding
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/execution"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Execution
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/planning"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Planning
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions/invoice-handling"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Invoice handling
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-3 sm:mb-4 text-white text-sm sm:text-base">
              COMPANY
            </h4>
            <ul className="space-y-2 text-sm sm:text-base">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  About us
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800/50 pt-6 sm:pt-8 text-center text-gray-400 text-xs sm:text-sm">
          <p>Copyright © 2025. Estabild AB. All rights reserved.</p>
          <p className="mt-1 sm:mt-2">Organization number: 559228-3211</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
